<template>
  <el-tooltip
      content="Copy to clipboard"
      effect="light"
      placement="top"
  >
    <span class="cursor-pointer" v-clipboard:copy="value" v-clipboard:success="onCopy" v-clipboard:error="onError">
      <slot>
        <i class="far fa-copy"></i>
      </slot>
  </span>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    value: String,
  },

  methods: {
    /**
     * @return {undefined}
     */
    onCopy() {
      this.$message({
        message: 'Copied!',
        type: 'success'
      });
    },

    /**
     * @return {undefined}
     */
    onError() {
      this.$message({
        message: 'Failed to copy the text',
        type: 'error'
      });
    },
  },
}
</script>
